import { ASSETS_BY_NAME_WITH_FILTER_QUERY } from '@/components/Filters/operations';
import { OIL_AND_GAS_MAP_SUBSCRIPTION } from '@/utils/constants';
import { useQuery } from '@apollo/client';

export const useGetAssets = ({ search = '', skip = false } = {}) => {
  const { data, loading, error } = useQuery(ASSETS_BY_NAME_WITH_FILTER_QUERY, {
    variables: {
      search,
      countries: [],
      companies: [],
      basins: [],
      geologyEpochIds: [],
      operator: false,
      nonOperator: false,
      isMAndAOpportunity: false,
      feature: OIL_AND_GAS_MAP_SUBSCRIPTION,
      includeHistoricalParticipants: false,
    },
    skip,
  });

  return {
    assets: data?.assetsByNameWithFilter?.assets || [],
    totalCount: data?.assetsByNameWithFilter?.totalCount || 0,
    loading,
    error,
  };
};
